import api from '@/services/api/api';

export const useWikiBySlug = (slug) => {
  const wikiBySlug = useQuery(
    ['wikiBySlug', slug],
    async () => {
      const { data } = await api.wikis.getWikiBySlug(slug);
      return data;
    },
    {
      enabled: computed(() => !!slug),
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await wikiBySlug.suspense();
  });

  return {
    wikiBySlug,
  };
};
